"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isZoeEmbedProperty = exports.zoeEmbedPropertyDefinition = void 0;
exports.zoeEmbedPropertyDefinition = {
    view: {
        label: 'Zoe embed',
        style: 'service-embed',
        hint: 'Place a ZOE engagement front and center on your page by using this field for your main hero section. Alternatively, keep this field empty. You have the option to position a ZOE engagement elsewhere on your page by selecting the embed component from the toolbar.',
    },
    constraints: [
        {
            name: 'providers',
            argument: ['ZOE'],
        },
    ],
    type: 'service',
    multiple: false,
    name: 'zoe-embed',
};
const isZoeEmbedProperty = (prop) => {
    return prop.name === exports.zoeEmbedPropertyDefinition.name;
};
exports.isZoeEmbedProperty = isZoeEmbedProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiem9lLWVtYmVkLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvem9lLWVtYmVkLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMEJBQTBCLEdBQUc7SUFDeEMsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLFdBQVc7UUFDbEIsS0FBSyxFQUFFLGVBQWU7UUFDdEIsSUFBSSxFQUFFLHVRQUF1UTtLQUM5UTtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLENBQUMsS0FBSyxDQUFDO1NBQ2xCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsU0FBUztJQUNmLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLFdBQVc7Q0FDYyxDQUFBO0FBSTFCLE1BQU0sa0JBQWtCLEdBQUcsQ0FBQyxJQUFrQixFQUE0QixFQUFFO0lBQ2pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxrQ0FBMEIsQ0FBQyxJQUFJLENBQUE7QUFDdEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxrQkFBa0Isc0JBRTlCIn0=